var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185 200 c-3 -5 -31 -10 -61 -10 -48 0 -59 -4 -92 -34 l-37 -35 27 -28 c22 -22 25 -32 16 -41 -6 -6 -8 -15 -5 -19 8 -7 177 155 177 169 0 11 -18 10 -25 -2z m-35 -29 c0 -6 -15 -11 -32 -13 -29 -3 -34 -7 -38 -37 -6 -42 -20 -48 -45 -21 -18 19 -18 21 1 41 10 12 28 25 39 30 28 11 75 11 75 0z m-35 -41 c-20 -22 -31 -20 -22 5 4 8 14 15 23 15 16 0 16 -2 -1 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 140 c18 -20 18 -21 -6 -46 -14 -13 -44 -28 -69 -33 l-45 -9 43 -1 c35 -1 49 5 80 33 36 34 37 34 18 55 -11 12 -24 21 -29 21 -6 0 -2 -9 8 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 98 c-15 -15 -16 -18 -3 -18 9 0 18 7 22 15 8 23 0 24 -19 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVisible);
export default __webpack_public_path__ + "static/media/not-visible.5c0a354519056a6ec936ef846aa0dbf0.svg";
export { ForwardRef as ReactComponent };